import React, { useState } from "react";
import { Card, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteEntityModal from "components/category/DeleteEntityModal";
import EditQuestionSubcategoryModal from "resources/questionCategory/list/components/EditQuestionSubcategoryModal";

const QuestionSubcategoryCard = ({ item }: {
    item: { id: string; name: string, position: number }
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleEdit = () => {
        setEditModalOpen(true);
        handleMenuClose();
    };

    const handleDelete = () => {
        setDeleteModalOpen(true);
        handleMenuClose();
    };

    return (
        <Card sx={{ px: 2, py: 1.5 }}>
            <Stack direction="row" spacing={2} justifyContent="space-between" alignItems="center">
                <Stack alignItems={'flex-start'}>
                    <Typography variant={'h6'}>{item.name}</Typography>
                </Stack>
                <IconButton onClick={handleMenuOpen}>
                    <MoreVertIcon/>
                </IconButton>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                    <MenuItem onClick={handleEdit}>Редактировать</MenuItem>
                    <MenuItem onClick={handleDelete}>Удалить</MenuItem>
                </Menu>
            </Stack>

            <EditQuestionSubcategoryModal
                isOpen={isEditModalOpen}
                onClose={() => setEditModalOpen(false)}
                subcategory={item}
            />

            <DeleteEntityModal
                isOpen={isDeleteModalOpen}
                onClose={() => setDeleteModalOpen(false)}
                entity={
                    {
                        id: item.id,
                        title: item.name
                    }
                }
                entityText={{
                    title: "Удалить подкатегорию",
                    success: "Подкатегория удалена",
                    error: "Ошибка при удалении подкатегории"
                }}
                resource={'question-subcategory'}
            />
        </Card>
    );
};

export default QuestionSubcategoryCard;